module.exports = __webpack_public_path__ + "static/media/Space Police Guy.2567ff6a.jpg";